import React from 'react';
import { Header } from '../components/site/Header';
import { Hero } from '../components/site/Hero';
import { Features } from '../components/site/Features';
import { About } from '../components/site/About';
import { Products } from '../components/site/Products';
import { ContactSection } from '../components/site/ContactSection';
import { Footer } from '../components/site/Footer';

const scrollToSection = (sectionId) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

const Home = () => (
  <div className="min-h-screen bg-black text-white" data-testid="home-page">
    <Header onNavigate={scrollToSection} />
    <Hero onNavigate={scrollToSection} />
    <Features />
    <About />
    <Products />
    <ContactSection />
    <Footer />
  </div>
);

export default Home;
